import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";
import {
  getTestData,
  downloadTestData,
  getYieldTestData,
  getAmortTestData,
  downloadAmortTestData
} from "store/state/calculators/testHarness";
import {
  LIBOR_FORWARD_CURVE,
  MARKET_EXPECTATIONS_SHOCK,
} from "../Constants/Constants";
import {FIXED_RATE, } from '../Constants/InterestRateType';
import AmortizationTab from './Amortization/AmortizationTab';
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class Amortization extends Component {
  state = {
    dayOfMonth: new Date().getDate(),
    curve: LIBOR_FORWARD_CURVE,
    shockType: MARKET_EXPECTATIONS_SHOCK,
    shockValue: 0,
    baseDate: moment(),
    tenorValue: 0,
    selectedTab: 3,

    loanAmount: 25000000,
    interestRateType: FIXED_RATE,
    interestRate: 0.0425,
    spread: "",

    startDate: moment(),
    loanTerm: 120,
    dayCount: "ACTUAL_OVER_365",
  };

  tablePaginationHelper = new TablePaginationHelper("e52dd1f6-33a8-4e8f-bd70-84fefa95a725", 10);

  submit = () => {
    const options = { ...this.state };
    options.page = this.tablePaginationHelper.page;
    options.pageSize = this.tablePaginationHelper.rowsPerPage;
    options.baseDate = options.baseDate.format("YYYY-MM-DD");    
    this.props.getTestData(options);
  };

  downloadTestData = () => {
    const options = { ...this.state, page: -1, pageSize: -1 };
    this.props.downloadTestData(options);
  };

  handleChangePage = (event, newPage) => {
    if (event) {
      this.tablePaginationHelper.page = newPage;
      this.submit();
    }
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.submit();
  };

  render() {
    return (
      <Fragment>
        <h4>Amortization</h4>
        <AmortizationTab/>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, testHarness }) => ({
  authentication,
  testHarness
});

export default compose(
  connect(
    mapStateToProps,
    {
      getTestData,
      downloadTestData,
      getYieldTestData,
      getAmortTestData,
      downloadAmortTestData
    }
  )
)(Amortization);
